import { Navigate, useLocation } from 'react-router-dom';

// This component checks if the user is authenticated
const PrivateRoute = ({ user, children }) => {
    const location = useLocation(); // Get current location

    // Check if the user is authenticated
    const isAuthenticated = user ? true : false;

    return isAuthenticated ? (
        children
    ) : (
        // Redirect to login with the current path as a state parameter
        <Navigate
            to="/login"
            replace
            state={{ from: location }} // Pass the current location to login page
        />
    );
};

export default PrivateRoute;
